import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { userService, auth } from '../../../../../services';
import './UserAccountPage.scss';
import AccountDetails from '../AccountDetails/AccountDetails';
import AccountPreference from '../AccountPreference/AccountPreference';
import ChangePassword from '../ChangePassword/ChangePassword';
import { history } from '../../../../../helpers/history';

class UserAccountPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			user: {},
			tabs: [{
					id: 'details',
					label: 'Account Details'
				},
				{
					id: 'preference',
					label: 'Account Preferences'
				},
				{
					id: 'password',
					label: 'Change Password'
				},
				{
					id: 'goBack',
					label: 'Back to Dashboard'
				}
			],
			activeTab: 'details',
			loading: true
		};
	}

	getUserProfile() {
		var userName = auth.getAuthUserEmail();
		if (userName) {
			userService.getUserProfile(userName).then(({ data }) => {
				this.setState({ user: data, loading: false });
			});
		}
	}

	profileUpdated = (profile) => {
		this.setState({ user: profile });
	};

	selectTab = (event) => {
		const target = event.target;
		this.setState({activeTab : target.id});
	}

	tabsContent = () => {
		switch(this.state.activeTab) {
			case 'details':
			  	return <AccountDetails />;
			case 'preference':
				return <AccountPreference />;
			case 'password':
				return <ChangePassword />;
			case 'goBack':
				return history.push('/dashboard');
			default:
			  	return null;
		  }
	}

	render() {
		return (
			<div className="membership-details">
                <div className="membership-details-container">
					<div className="cols">
						<div className="col-md-4 col-sm-12 col-left">
							{/* <div className="list-group account-tabs">
								{
									this.state.tabs.map((tab, index) => {
										const cls = 'list-group-itemXX list-group-item-actionXX';
										return (
											<a
												className = {tab.id == this.state.activeTab ? `${cls} active` : cls} 
												onClick={this.selectTab}
												id={tab.id}
												key = {index}>
											{tab.label}
										</a>
										);
									})
								}
							</div> */}

							<ul className="list-group account-tabs">
								{this.state.tabs.map((tab, index) => {
									const cls = 'list-group-itemXX list-group-item-actionXX';
									return (
										<li className="list-group-item" key={tab.id}>
											<a className={tab.id == this.state.activeTab ? `${cls} active` : cls}
											onClick={this.selectTab}
											id={tab.id}
											key={index}
											>{tab.label}</a>
										</li>
									);
								})}
							</ul>

						</div>
						<div className="flex-grow-1XX col-md-8 col-sm-12 col-right">
								{this.tabsContent()}
						</div>
					</div>
				</div>
            </div>
		);
	}
}

export default withRouter(connect(null, null)(UserAccountPage));
